export const SortValues = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  NONE: 'none'
};
export const SortIntegerValues = {
  ASCENDING: -1,
  DESCENDING: 1
};
export const CRMSearchSortValue = {
  ASCENDING: 'ASC',
  DESCENDING: 'DESC'
};
export const CRMSearchToIntegerSort = {
  ASC: SortIntegerValues.ASCENDING,
  DESC: SortIntegerValues.DESCENDING
};
export const IntegerSortToCRMSearch = {
  [SortIntegerValues.ASCENDING]: CRMSearchSortValue.ASCENDING,
  [SortIntegerValues.DESCENDING]: CRMSearchSortValue.DESCENDING
};